<template>
  <v-card max-width="200" class="mr-1 mb-1">
    <v-img v-if="!!video.preview_url && video.status==='done'"
           class="white--text align-end"
           :src="video.preview_url"
    />
    <v-alert
      v-if="video.broken_message"
      class="my-0 pa-1"
      outlined
      color="error"
    >
      <div
        v-for="(message, id) in video.broken_message"
        :key="id"
        >
        - {{ message }}
      </div>
    </v-alert>
    <v-alert
      v-if="video.status==='fail'"
      outlined
      type="error"
    >
      Saving to database is failed
    </v-alert>
    <v-alert
      v-if="video.status==='in_progress'"
      outlined
      type="warning"
    >
      Uploading in progress
    </v-alert>
    <v-alert
      v-if="!video.preview_url && video.status==='done'"
      outlined
      type="info"
    >
      Has no preview
    </v-alert>
    <v-container
      v-if="video.error && video.error[0]['id'] !== 0"
      class="ma-0 pa-0"
    >
      <v-alert
        v-for="error in video.error"
        :key="error.id"
        outlined
        color="error"
      >
        {{ error.name }}
      </v-alert>
    </v-container>
    <v-card-actions class="card-actions-left">
      <v-btn
        v-if="video.status === 'done'"
        x-small fab
        @click="openPlayVideoDialog(video.uri)"
      >
        <v-icon>
          mdi-play
        </v-icon>
      </v-btn>
    </v-card-actions>

    <v-card-actions class="card-actions-right">

      <v-menu
        left
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            x-small fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-btn
              depressed
              small
              @click="updateVideoInfo(video.id)"
            >
              update info
            </v-btn>
          </v-list-item>
          <v-list-item
            v-if="!isExcludeToggleHideButton"
          >
            <v-btn
              depressed
              small
              @click="toggleHideVideo(video.id)"
            >
              {{ !video.is_hidden ? 'hide' : 'reveal' }}
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              depressed
              small
              @click="deleteVideo(video.id)"
            >
              delete
              <v-icon
                color="red"
              >
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-card-actions>

    <slot>
      <v-card-title
       class="purple darken-2 text-caption flex-column align-start pa-1">
        <div class="white--text"> Status: {{ video.status }} </div>
        <div class="white--text"> POI ID: {{
            video.poi
              ? video.poi.id : 'unset'
          }} </div>
        <div class="white--text"> ID: {{ video.id}} </div>
        <div class="white--text"> Source: <span class="font-weight-bold">{{video.videosource
          ? video.videosource.name
          : 'empty' }}</span>
        </div>
        <div class="white--text">
          Display order: <span class="font-weight-bold"
        >{{video.priority
          ? video.priority.name
          : 'empty' }}</span>
        </div>
      </v-card-title>
    </slot>
  </v-card>

</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
    hiddenButtons: {
      type: Array,
      default: () => ([]),
    },
  },
  name: 'VideoPreviewCard',
  methods: {
    toggleHideVideo(videoId) {
      this.$emit('init');

      this.$requestHelpers
        .get(`api/admin/videodata/toggleHideBrokenVideo/${videoId}`)
        .then((response) => {
          this.$emit('toggleHideVideo', { videoId, response });
        }).finally(() => {
          this.$emit('finally');
        });
    },

    updateVideoInfo(videoId) {
      this.$emit('init');

      this.$requestHelpers
        .get(`api/admin/videodata/updateInfo/${videoId}`)
        .then((response) => {
          this.$emit('updateVideoInfo', { videoId, response });
        }).finally(() => {
          this.$emit('finally');
        });
    },

    deleteVideo(videoId) {
      this.$confirm('Are you sure you want to delete this video?').then((res) => {
        if (!res) return;

        this.$emit('init');

        this.$requestHelpers
          .delete(`api/admin/videodata/${videoId}`)
          .then(() => {
            this.$emit('deleteVideo', videoId);
          }).finally(() => {
            this.$emit('finally');
          });
      });
    },

    openPlayVideoDialog(videoSrc) {
      this.$emit('openPlayVideoDialog', videoSrc);
    },
  },

  computed: {
    isExcludeToggleHideButton() {
      return this.hiddenButtons.includes('toggleHidden');
    },
  },
};
</script>

<style scoped>
.card-actions-left {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0;
}
.card-actions-right {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
}
</style>
